import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { isNotNil, isNotNilOrEmpty } from 'utils/ramda'

export const PhoneField = props => {
  const {
    name = '',
    onChange = () => {},
    validate = () => {},
    label = '',
    value: initialValue,
    disabled = false,
    clearValueTrigger = '',
    nomarginbottom = false,
    noValidation = false,
    optional = false
  } = props

  const [touched, _setTouched] = useState(false)
  const [value, _setValue] = useState(initialValue || '')
  const [selectedCountry, setSelectedCountry] = useState({ dialCode: '44', countryCode: 'gb' })
  const [valid, _validate] = useState(false)

  const hasError = !valid && touched && !disabled

  useEffect(() => {
    _setValue('')
  }, [clearValueTrigger])

  useEffect(() => {
    if (isNotNil(initialValue)) {
      _setValue(initialValue)
    }
    if (isNotNilOrEmpty(initialValue)) {
      _setTouched(true)
    }
  }, [initialValue])

  const handleBlur = () => {
    _setTouched(true)
  }

  const handleChange = (val, country) => {
    _setValue(val)
    onChange(name, val)
    setSelectedCountry(country)
    if (!touched) _setTouched(true)
  }

  useEffect(() => {
    if (noValidation) {
      _validate(true)
    } else if (optional && (value === '' || value === undefined)) {
      _validate(true)
    } else if (value) {
      const digits = value.replace(/\D/g, '')

      _validate(digits.length >= 8 && digits.length <= 15)
    } else {
      _validate(false)
    }
  }, [value, touched, noValidation, optional])

  useEffect(() => {
    validate && validate(valid)
  }, [valid])

  return (
    <InputWrapper nomarginbottom={nomarginbottom} className={hasError ? 'has-error' : ''}>
      <Label>
        {label}
        {!optional && <RequiredStar>*</RequiredStar>}
        {optional && <OptionalText>(Optional)</OptionalText>}
      </Label>
      <PhoneInput
        {...props}
        onBlur={handleBlur}
        country='gb'
        onChange={handleChange}
        value={value}
        disabled={disabled}
        autoFormat
        inputStyle={{
          width: '100%',
          height: '44px',
          borderColor: hasError ? '#EF4444' : '#E5E7EB',
          backgroundColor: disabled ? '#F3F4F6' : 'white'
        }}
        buttonStyle={{
          borderColor: hasError ? '#EF4444' : '#E5E7EB',
          backgroundColor: disabled ? '#F3F4F6' : 'white'
        }}
      />
      {hasError && <ErrorMessage>Incorrect phone number</ErrorMessage>}
    </InputWrapper>
  )
}

export default PhoneField

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: ${({ nomarginbottom }) => (nomarginbottom ? 0 : '16px')};
  width: 100%;

  .react-tel-input .form-control:focus {
    border-color: #33becc !important;
    box-shadow: 0 0 0 1px #33becc !important;
  }

  &.has-error .react-tel-input .form-control:focus {
    border-color: #EF4444 !important;
    box-shadow: 0 0 0 1px #EF4444 !important;
  }
`

const Label = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 13px;
  color: #374151;
`

const RequiredStar = styled.span`
  color: #EF4444;
  margin-left: 4px;
`

const OptionalText = styled.span`
  font-weight: 400;
  color: #9CA3AF;
  font-size: 11px;
  margin-left: 4px;
`

const ErrorMessage = styled.div`
  font-size: 12px;
  color: #EF4444;
  margin-top: 6px;
  text-align: left;
  display: block;
`
